var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13,
    x: 19,
    height: 5.9999995,
    width: 5.9999995,
    id: "rect845",
    style: {
      fill: "#000000",
      fillOpacity: 0.1,
      fillRule: "evenodd",
      strokeWidth: 0.809628,
      imageRendering: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 0.1,
      fillRule: "evenodd",
      strokeWidth: 0.809631,
      imageRendering: "auto"
    },
    id: "rect845-1",
    width: 5.9999995,
    height: 5.9999995,
    x: 29,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 0.1,
      fillRule: "evenodd",
      strokeWidth: 0.809628,
      imageRendering: "auto"
    },
    id: "rect845-4",
    width: 6,
    height: 5.9999995,
    x: 18.999998,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23,
    x: 29,
    height: 5.9999995,
    width: 6,
    id: "rect845-1-5",
    style: {
      fill: "#000000",
      fillOpacity: 0.1,
      fillRule: "evenodd",
      strokeWidth: 0.809631,
      imageRendering: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 33,
    x: 18.999998,
    height: 5.9999995,
    width: 6,
    id: "rect902",
    style: {
      fill: "#000000",
      fillOpacity: 0.1,
      fillRule: "evenodd",
      strokeWidth: 0.809628,
      imageRendering: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 0.1,
      fillRule: "evenodd",
      strokeWidth: 0.809631,
      imageRendering: "auto"
    },
    id: "rect904",
    width: 6,
    height: 5.9999995,
    x: 29,
    y: 33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.0cb86de3bcc30b498680103120daab53.svg";
export { ForwardRef as ReactComponent };